<template>
  <div>
    <v-menu v-model="current.opened" :close-on-content-click="false" max-width="290px" min-width="290px">
      <template v-slot:activator="{ on }">
        <v-btn text outlined small v-on="on" :color="$moment(current.date).hour() === 0 ? '' : 'success'" class="mr-1">
          <v-icon left v-if="$moment(current.date).hour() === 0">mdi-calendar-clock</v-icon>
          <v-icon left v-else>mdi-account-clock</v-icon>
          <span v-if="$moment(current.date).hour() !== 0">{{ $moment(current.date).format('lll') }}</span>
          <span v-else>{{ $moment(current.date).format('ll') }}</span>
        </v-btn>
      </template>
      <v-date-picker
        full-width
        :value="current.date"
        @input="current.opened = false"
        :events="getDatePickerEvents"
        :show-current="$moment(current.date).format('YYYY-MM-DD')"
        event-color="primary"
        @click:date="handleCurrentDatePickerClick"
      >
      </v-date-picker>
    </v-menu>
    {{ $t('compared') }}
    <v-menu v-model="comparison.opened" :close-on-content-click="false" max-width="290px" min-width="290px">
      <template v-slot:activator="{ on }">
        <v-btn text outlined small v-on="on" :color="$moment(comparison.date).hour() === 0 ? '' : 'success'" class="ml-1">
          <v-icon left v-if="$moment(comparison.date).hour() === 0">mdi-calendar-clock</v-icon>
          <v-icon left v-else>mdi-account-clock</v-icon>
          <span v-if="$moment(comparison.date).hour() !== 0">{{ $moment(comparison.date).format('lll') }}</span>
          <span v-else>{{ $moment(comparison.date).format('ll') }}</span>
        </v-btn>
      </template>
      <v-date-picker
        full-width
        :value="comparison.date"
        @input="comparison.opened = false"
        :min="$account.current.created_at"
        :show-current="$moment(comparison.date).format('YYYY-MM-DD')"
        :events="getDatePickerEvents"
        event-color="primary"
        @click:date="handleComparisonDatePickerClick"
      >
      </v-date-picker>
    </v-menu>
  </div>
</template>

<script>
import moment from 'moment'

export default {
  name: 'DatePicker',
  props: ['currentDate', 'comparisonDate'],
  data () {
    const current = this.currentDate ? moment(this.currentDate) : moment().clone().set({ hour: 0, minute: 0 })
    const comparison = this.comparisonDate ? moment(this.comparisonDate) : moment().clone().subtract(1, 'day').set({
      hour: 0,
      minute: 0
    })

    return {
      current: {
        date: current.format('YYYY-MM-DD HH:mm'),
        opened: false
      },
      comparison: {
        date: comparison.format('YYYY-MM-DD HH:mm'),
        opened: false
      }
    }
  },
  computed: {
    customReports () {
      return this.$services.monitoring.computedReportList
    }
  },
  watch: {
    currentDate (current) {
      this.current.date = moment(current).clone().format('YYYY-MM-DD HH:mm')
    },
    comparisonDate (comparison) {
      this.comparison.date = moment(comparison).clone().format('YYYY-MM-DD HH:mm')
    },
    'current.date' () {
      this.fireChanged()
    },
    'comparison.date' () {
      this.fireChanged()
    }
  },
  methods: {
    getDatePickerEvents (date) {
      let events = []
      this.$services.monitoring.computedReportList.forEach(reportDate => {
        if (date === reportDate.substr(0, 10) && events.length < 3) {
          events = ['success']
        }
      })
      return events.length > 0 ? events : false
    },
    fireChanged () {
      this.$emit('changed', {
        current: this.current.date,
        comparison: this.comparison.date
      })
    },
    handleCurrentDatePickerClick (date) {
      if (this.customReports.filter(report => moment(report).isSame(date, 'day')).length) {
        this.$ui.openDialog('choose_day_report', {
          date, callback: (date) => this.applyCurrent(date)
        })
      } else {
        this.applyCurrent(moment(date).format('YYYY-MM-DD 00:00'))
      }
    },
    handleComparisonDatePickerClick (date) {
      if (this.customReports.filter(report => moment(report).isSame(date, 'day')).length) {
        this.$ui.openDialog('choose_day_report', {
          date, callback: (date) => this.applyComparison(date)
        })
      } else {
        this.applyComparison(moment(date).format('YYYY-MM-DD 00:00'))
      }
    },
    applyCurrent (date) {
      this.current.date = date

      if (moment(this.comparison.date).isSameOrAfter(date, this.$t('minute'))) {
        if (moment(date).hour() !== 0 && moment(date).minute() !== 0) {
          this.applyComparison(moment(date).clone().format('YYYY-MM-DD 00:00'))
        } else {
          this.applyComparison(moment(date).clone().subtract(1, 'day').format('YYYY-MM-DD 00:00'))
        }
      }
    },
    applyComparison (date) {
      if (moment(this.current.date).isBefore(date, 'day')) {
        this.$ui.warning(this.$t('comparison'))
      } else {
        this.comparison.date = date
      }
    },
  }
}
</script>

<style scoped>

</style>

<i18n>
{
	"en": {
		"compared": "compared to ",
		"comparison": "Cannot compare today's data with a future date.",
		"minute": "minute"
	},
	"es": {
		"compared": "en comparación con ",
		"comparison": "No se pueden comparar los datos de hoy con una fecha futura.",
		"minute": "minuto"
	},
	"fr": {
		"compared": "comparé à ",
		"comparison": "Impossible de comparer les données du jour avec une date future.",
		"minute": "minute"
	},
	"it": {
		"compared": "rispetto a ",
		"comparison": "Impossibile confrontare i dati odierni con una data futura.",
		"minute": "minuto"
	},
	"pt": {
		"compared": "comparado com ",
		"comparison": "Impossível comparar os dados de hoje com uma data futura.",
		"minute": "minuto"
	},
	"pl": {
		"compared": "w porównaniu z ",
		"comparison": "Nie można porównywać dzisiejszych danych z datą w przyszłości.",
		"minute": "minuta"
	}
}
</i18n>
